import { useState } from 'react';

import { addYears, subYears } from 'date-fns';
import { useTranslation } from 'react-i18next';

import EventIcon from '@mui/icons-material/Event';
import { Box, Button, IconButton, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';

import { Tile } from 'components/shared';

import { useStartRecalculationMutation } from './queries';

const HourManagement = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const [yearDate, setYearDate] = useState<Date | null>(new Date());

  const { mutate: recalculateForYearDate } = useStartRecalculationMutation();

  const onChangeDate = (d: Date | null) => {
    setYearDate(d);
    setOpen(false);
  };

  const onClickRecalculate = () => {
    if (!yearDate) {
      return;
    }

    recalculateForYearDate(yearDate);
  };

  return (
    <Box>
      <Tile title={t('adminPortal.realization.recalculateHourManagement.name')}>
        <Typography
          variant="body2"
          sx={{ fontFamily: 'signikalight!important' }}
        >
          {t('adminPortal.realization.recalculateHourManagement.description')}
        </Typography>
        <Box mt={2} display="flex" gap={2}>
          <DatePicker
            views={['year']}
            label={t('year')}
            value={yearDate}
            open={open}
            onChange={onChangeDate}
            minDate={subYears(new Date(), 10)}
            maxDate={addYears(new Date(), 10)}
            renderInput={(params) => (
              <TextField
                {...params}
                name={t('year')}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={() => setOpen((prev) => !prev)}
                      size="small"
                    >
                      <EventIcon />
                    </IconButton>
                  )
                }}
              />
            )}
          />
          <Button
            variant="outlined"
            onClick={onClickRecalculate}
            disabled={!yearDate}
          >
            {t('adminPortal.realization.recalculateHourManagement.recalculate')}
          </Button>
        </Box>
      </Tile>
    </Box>
  );
};

export default HourManagement;
